import "./style.css"

function RestrictedPage ({isLoggedIn, user, Login, Logout}){
    return(
        <div>
            {isLoggedIn ? (
                <>
                    <h2>Bem-vido {user}!</h2>
                    <button onClick={Logout}>Sair</button>
                </>
            ): 
            <>
                <h2>Você não pode acessar esta página</h2>
                <button onClick={Login}>Entrar</button>
            </>}
        </div>
    )
}

export default RestrictedPage